// Components, Layouts, Pages
import {
  AdministrativeAreaPageAdmin,
  CoursePageAdmin,
  DashboardPageAdmin,
  DiscussionPageAdmin,
  StudentDetailPageAdmin,
  StudentPageAdmin,
  TuitionAreaPageAdmin,
} from '~/pages/admin';
import { IRouteModel } from '~/utils/interface/base';
// Others
// Styles, images, icons

export const adminRoute = {
  base: '/admin',

  // Common
  commonCreate: '/create',
  commonDetail: '/:id',

  tuitionArea: '/tuition-area',
  administrativeArea: '/exam-area',
  courses: '/courses',
  students: '/students',
  studentDetail: '/:studentId',
  discussions: '/discussions',
};

export const privateAdminRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${adminRoute.base}`,
    component: DashboardPageAdmin,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.tuitionArea}`,
    component: TuitionAreaPageAdmin,
    name: 'TuitionArea',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.administrativeArea}`,
    component: AdministrativeAreaPageAdmin,
    name: 'AdministrativeArea',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.courses}`,
    component: CoursePageAdmin,
    name: 'Course',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.students}`,
    component: StudentPageAdmin,
    name: 'Student',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.students}${adminRoute.studentDetail}`,
    component: StudentDetailPageAdmin,
    name: 'StudentDetail',
  },
  {
    index: true,
    path: `${adminRoute.base}${adminRoute.discussions}`,
    component: DiscussionPageAdmin,
    name: 'Discussion',
  },
];

export const adminRouteAbsolute = {
  dashboard: `${adminRoute.base}`,
};
